var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-overlay n-content" }, [
    _c(
      "div",
      {
        staticClass: "in-content",
        class: { clsng: _vm.Global.tempClosingOverlay },
      },
      [
        _c("div", { staticClass: "head" }, [
          _c("h5", [
            _c("span", { staticClass: "txt-grt" }, [_vm._v("Add new content")]),
            _vm._v(" "),
            _c("span", { staticClass: "steps" }, [
              _vm._v(_vm._s(_vm.currentStep) + "/3"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "x",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closeContentOverlay.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 22 22",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.4706 2.5L2.5 19.4706",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.4706 19.4706L2.5 2.5",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inner-content" }, [
          _c(
            "div",
            { staticClass: "lft" },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  _c(
                    "keep-alive",
                    { attrs: { max: "3" } },
                    [
                      _vm.currentStep == 1
                        ? _c("NewContentOne", {
                            on: {
                              nxt: function ($event) {
                                return _vm.goTo(2)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep == 2
                        ? _c("NewContentTwo", {
                            on: {
                              prv: function ($event) {
                                return _vm.goTo(1)
                              },
                              nxt: function ($event) {
                                return _vm.goTo(3)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep == 3
                        ? _c("NewContentThree", {
                            on: {
                              prv: function ($event) {
                                return _vm.goTo(2)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col rgt" }, [
            _c("p", { staticClass: "step-caption ft-bld" }, [
              _vm._v("Preview of your content"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card-preview",
                class: [
                  "radius" + _vm.Global.mockupConfig.radiusRatio,
                  _vm.Global.mockupConfig.activeFont,
                ],
              },
              [
                _c("div", { staticClass: "top", style: _vm.placeholderBg }, [
                  _c("div", {
                    staticClass: "pic cvr no-pointer",
                    style: {
                      backgroundImage:
                        "url(" + _vm.Global.newContentOverlay.poster + ")",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "infos col" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ft-bld p-tag",
                        style: {
                          backgroundColor: _vm.Global.mockupConfig.colors.icons,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.Global.plans[
                              _vm.Global.newContentOverlay.planIndex
                            ].name
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "ft-xbld p-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.Global.newContentOverlay.name || "Content name"
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bottom" }, [
                  _c("div", { staticClass: "actions" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn main ply",
                        class: {
                          sub: _vm.Global.newContentOverlay.planIndex !== 0,
                        },
                        style: {
                          background: _vm.Global.mockupConfig.colors.icons,
                        },
                      },
                      [
                        _c("span", { staticClass: "ico" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "21",
                                height: "24",
                                viewBox: "0 0 21 24",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z",
                                  fill: "black",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "txt" }, [
                          _vm._v(
                            _vm._s(
                              _vm.Global.newContentOverlay.planIndex !== 0
                                ? "Subscribe"
                                : "Play"
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sqr i" }, [
                      _c("span", { staticClass: "ico" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "26",
                              height: "26",
                              viewBox: "0 0 26 26",
                              fill: "none",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "13",
                                cy: "13",
                                r: "13",
                                fill: "white",
                              },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: {
                                cx: "13",
                                cy: "7",
                                r: "2",
                                fill: "#696969",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M13 12V19",
                                stroke: "#696969",
                                "stroke-width": "3",
                                "stroke-linecap": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sqr add" }, [
                      _c("span", { staticClass: "ico" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "26",
                              height: "26",
                              viewBox: "0 0 26 26",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M13 2V24",
                                stroke: "white",
                                "stroke-width": "4",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M2 13H24",
                                stroke: "white",
                                "stroke-width": "4",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sqr vol" }, [
                      _c("span", { staticClass: "ico" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "29",
                              height: "23",
                              viewBox: "0 0 29 23",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M6.5 6.91872H3.33333C2.59733 6.91872 2 7.51605 2 8.25205V14.5854C2 15.3214 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4134C12.672 21.1481 14 20.5321 14 19.3961V3.44138C14 2.30538 12.6707 1.68938 11.8053 2.42405L6.5 6.91872Z",
                                fill: "white",
                                stroke: "white",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M19.3828 16.7226C20.9321 15.76 22.0001 13.7573 22.0001 11.4253C22.0001 9.09329 20.9321 7.08929 19.3828 6.11462",
                                stroke: "white",
                                "stroke-width": "3",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M23.3407 20.8387C25.7513 18.7653 27.334 15.3253 27.334 11.4227C27.334 7.51467 25.7487 4.072 23.334 2",
                                stroke: "white",
                                "stroke-width": "3",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "sum" }, [
                    _vm._v(
                      _vm._s(
                        _vm.Global.newContentOverlay.description ||
                          "Content description"
                      )
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }